const MenuSafari = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      data-testid="safari-browser-icon"
    >
      <path
        d="M10.99 5.80569H11.809C12.743 5.80569 13.5 6.57769 13.5 7.53069V13.2747C13.5 14.2277 12.743 14.9997 11.809 14.9997H4.191C3.257 14.9997 2.5 14.2277 2.5 13.2747V7.52969C2.5 6.57669 3.257 5.80469 4.191 5.80469H5.076"
        stroke="white"
        strokeWidth="1.4"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M8.00006 8.333V1M8.00006 1L5.78906 3.266M8.00006 1L10.2111 3.267"
        stroke="white"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MenuSafari;
